'use client';

import { Monetization } from '@eqi-investimentos/icons/web';
import { Button } from '@eqi-investimentos/react';
import { MODAL_INVEST_ID } from '@/components/modules/InvestModal';

export const InvestFloatingButton = () => (
  <Button
    data-testid="invest-floating-button"
    position="absolute"
    bottom="xl"
    right="6rem"
    zIndex="docked"
    borderRadius="50%"
    boxSize="3.4994rem"
    onClick={() =>
      window.dispatchEvent(new Event(`open-chakra-modal-${MODAL_INVEST_ID}`))
    }
  >
    <Monetization boxSize="2rem !important" />
  </Button>
);
